const testimonials = [
  {
    name: "Lauren H.",
    location: "Buckhead, GA",
    rating: 5,
    text: "I had a business trip to London in 4 days and realized my passport had expired. Fast Passport Center got me an expedited passport in under 72 hours. Their team was responsive and kept me updated every step of the way.",
    service: "Emergency Passport",
  },
  {
    name: "David S.",
    location: "Brookhaven, GA",
    rating: 5,
    text: "Our family cruise to the Caribbean was booked and my son's passport was about to expire. Fast Passport Center handled the child passport renewal smoothly. They told us exactly which Buckhead post office to visit for the clerk step.",
    service: "Child Passport",
  },
  {
    name: "Rachel T.",
    location: "Midtown Atlanta, GA",
    rating: 5,
    text: "After a divorce, I needed my name changed on my passport before a work trip to Tokyo. Fast Passport Center walked me through the exact documents needed and had my expedited passport back in a week. Could not recommend them more.",
    service: "Name Change",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function BuckheadTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What North Atlanta Travelers Say About Our Expedited Passport Service
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from real travelers across Buckhead, Brookhaven, Midtown, and north Atlanta who trusted Fast Passport Center with their emergency and expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}